import { BRAND_LIST, COUNTRY, LANGUAGE } from "@type/index";

export const contactUsUrl: { [key: string]: string } = {
  [`${BRAND_LIST.UQ}${COUNTRY.AT}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.AU}${LANGUAGE.EN}`]: "https://faq-au.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.BE}${LANGUAGE.EN}`]: "https://faq-be.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.BE}${LANGUAGE.FR}`]:
    "https://faq-be.uniqlo.com/pkb_Home_UQ_BE?l=fr",
  [`${BRAND_LIST.UQ}${COUNTRY.BE}${LANGUAGE.NL}`]:
    "https://faq-be.uniqlo.com/pkb_Home_UQ_BE?l=nl_NL",
  [`${BRAND_LIST.UQ}${COUNTRY.BG}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.CA}${LANGUAGE.EN}`]: "https://faq-ca.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.CA}${LANGUAGE.FR}`]:
    "https://faq-ca.uniqlo.com/pkb_Home?l=fr",
  [`${BRAND_LIST.UQ}${COUNTRY.CZ}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.DE}${LANGUAGE.DE}`]: "https://faq-de.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.DE}${LANGUAGE.EN}`]:
    "https://faq-de.uniqlo.com/pkb_Home_UQ_DE?l=en_US",
  [`${BRAND_LIST.UQ}${COUNTRY.DK}${LANGUAGE.EN}`]: "https://faq-dk.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.EE}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.ES}${LANGUAGE.EN}`]:
    "https://faq-es.uniqlo.com/pkb_Home_UQ_ES?l=en_US",
  [`${BRAND_LIST.UQ}${COUNTRY.ES}${LANGUAGE.ES}`]: "https://faq-es.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.FI}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.FR}${LANGUAGE.EN}`]:
    "https://faq-fr.uniqlo.com/pkb_Home_UQ_FR?l=en_US",
  [`${BRAND_LIST.UQ}${COUNTRY.FR}${LANGUAGE.FR}`]: "https://faq-fr.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.GR}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.HR}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.HU}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.ID}${LANGUAGE.EN}`]: "https://faq-id.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.ID}${LANGUAGE.ID}`]:
    "https://faq-id.uniqlo.com/pkb_Home_UQ_ID?l=in",
  [`${BRAND_LIST.UQ}${COUNTRY.IE}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.IN}${LANGUAGE.EN}`]:
    "https://faq-in.uniqlo.com/contactus/",
  [`${BRAND_LIST.UQ}${COUNTRY.IT}${LANGUAGE.EN}`]:
    "https://faq-it.uniqlo.com/pkb_Home_UQ_IT?l=en_US",
  [`${BRAND_LIST.UQ}${COUNTRY.IT}${LANGUAGE.IT}`]: "https://faq-it.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.JP}${LANGUAGE.JA}`]: "https://faq.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.KR}${LANGUAGE.KO}`]: "https://faq-kr.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.LT}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.LU}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.LV}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.MY}${LANGUAGE.EN}`]:
    "https://faq-my.uniqlo.com/contactus",
  [`${BRAND_LIST.UQ}${COUNTRY.NL}${LANGUAGE.EN}`]: "https://faq-nL.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.NL}${LANGUAGE.NL}`]:
    "https://faq-nl.uniqlo.com/pkb_Home_UQ_NL?l=nl_NL",
  [`${BRAND_LIST.UQ}${COUNTRY.PH}${LANGUAGE.EN}`]:
    "https://faq-ph.uniqlo.com/contactus",
  [`${BRAND_LIST.UQ}${COUNTRY.PL}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.PT}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.RO}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.SE}${LANGUAGE.EN}`]: "https://faq-se.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.SG}${LANGUAGE.EN}`]:
    "https://faq-sg.uniqlo.com/contactus/",
  [`${BRAND_LIST.UQ}${COUNTRY.SI}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.SK}${LANGUAGE.EN}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.TH}${LANGUAGE.EN}`]:
    "https://faq-th.uniqlo.com/contactusen/",
  [`${BRAND_LIST.UQ}${COUNTRY.TH}${LANGUAGE.TH}`]:
    "https://faq-th.uniqlo.com/contactus/",
  [`${BRAND_LIST.UQ}${COUNTRY.UK}${LANGUAGE.EN}`]: "https://faq-uk.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.US}${LANGUAGE.EN}`]: "https://faq-us.uniqlo.com",
  [`${BRAND_LIST.UQ}${COUNTRY.VN}${LANGUAGE.EN}`]:
    "https://faq-vn.uniqlo.com/contactusen",
  [`${BRAND_LIST.UQ}${COUNTRY.VN}${LANGUAGE.VI}`]:
    "https://faq-vn.uniqlo.com/contactus",
  [`${BRAND_LIST.GU}${COUNTRY.JP}${LANGUAGE.JA}`]: "https://faq.gu-global.com/",
  [`${BRAND_LIST.GU}${COUNTRY.US}${LANGUAGE.EN}`]:
    "https://faq-us.gu-global.com",
  [`${BRAND_LIST.PL}${COUNTRY.JP}${LANGUAGE.JA}`]: "https://faq.plst.com/"
};
